import React from 'react'
import { ScrollView, StyleSheet, Text, View } from 'react-native'

//import ConfettiCelebration from '@/components/Mini/ConfettiCelebration' 

import * as d10 from '@/router/(root)/daily10/d10Module'
import { D10Background as Background } from "@/components/Mini/Background"
import { D10Header as Header } from "@/components/Mini/Header"
import { D10StatsCard as StatsCard} from "@/components/Mini/StatsCard"
import { D10StreakStats as StreakStats} from "@/components/Mini/StreakStats"
import { D10LeaderboardCard as LeaderboardCard} from "@/components/Mini/LeaderboardCard"
import { PrimaryBtn, SecondaryBtn } from "@/components/Mini/Button"
import { D10DiamondsCard as DiamondsCard } from "@/components/Mini/DiamondsCard"

import type { MinigameModule } from '@/types/minigameModule'

function Daily10ResultsScreen(){

  const m = d10

  //isPerfect not applicable in d10
  //const isPerfect = m.useIsPerfect()

  const { isAdmin, isSuperAdmin } = m.useD10User()

  return (
    <>
    {/*isPerfect && <ConfettiCelebration />*/}
    <Background>
          <ResultsScreenHeader m={m}/>
          <ScrollView contentContainerStyle={styles.scrollContent} showsVerticalScrollIndicator={false}>
            <StatsCard />
            {(isAdmin || isSuperAdmin) && <DiamondsCard />}
            <StreakStats />
            <LeaderboardCard compact={true} />
          </ScrollView>
          <Footer />
    </Background>
    </>

  )

}

function ResultsScreenHeader ({ m }: { m: MinigameModule }) {

  const handleHome = m.useHandleHome()

  return (
    <Header title="Your Results" handler={handleHome} />
  )
}

function Footer(){

  return (
    <View style={styles.footer}>
      <ShareBtn />
    </View>
  )
  
}

function ShareBtn(){

  const m = d10

  const handleShare = m.useHandleShare()

  const theme = m.useStore(s => s.theme)

  return (
    <PrimaryBtn theme={theme} handler={handleShare} label="Share your results" />
  )
}


const styles = StyleSheet.create({
  fill: { flex: 1 },
  scrollContent: { paddingHorizontal: 16, paddingBottom: 16,  gap: 16 },
  footer: { paddingHorizontal: 24, paddingBottom: 16, paddingTop: 8, gap: 12 }
})

export { Daily10ResultsScreen }
